import { IUser } from 'app/shared/model/user.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IUserCustom {
  id?: number;
  phone?: string | null;
  activated?: boolean | null;
  registry?: string | null;
  identificationCode?: string | null;
  licenseValidity?: string | null;
  user?: IUser | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IUserCustom> = {
  activated: false,
};
